import moment from "moment";
import AppMessages from "../../config/AppMessages";
import { isAppleDevice } from "../utils";
import { find } from "lodash";

const showNoCalendarsNotification = (controller) => {
  const { enable_notifications, notification_time, show_admin_tools } =
    controller.state.settings || {};

  // TODO: remove when deeplink is ready
  if (!show_admin_tools) return;

  if (!enable_notifications || !notification_time) return;

  const devices = controller.state?.settings?.devices || {};
  let calendarsCount = -1; // Calendars not connected
  Object.keys(devices).forEach((key) => {
    if (key.indexOf("calendar") > -1) {
      // Calendars connected, but no toggle is ON
      if (calendarsCount == -1) {
        calendarsCount = 0;
      }

      (devices[key] || []).forEach((d) => {
        if (d.isEnabled) calendarsCount++;
      });
    }
  });

  const startTime = moment(notification_time, "hh:mm")
    .add(-2, "hours")
    .format("YYYY-MM-DDTHH:mm:00");

  // Only for iOS
  if (isAppleDevice && calendarsCount == 0) {
    const calNotification = {
      title: AppMessages.NoCalendarsNotificationsTitle,
      message: AppMessages.NoCalendarsNotificationsMessage,
      start_time: startTime,
      recurrent: true,
    };

    if (controller.state.settings?.notifications) {
      const n = find(
        controller.state.settings?.notifications,
        (not) => not.title == calNotification.title,
      );
      // Only one
      if (!n) {
        controller.state.settings.notifications.push(calNotification);
      }
    }
  }
};

const NotificationsHelper = {
  showNoCalendarsNotification,
};

export default NotificationsHelper;
